(function () {
  'use strict';

  angular.module('app').service('PaymentProviderModalService', PaymentProviderModalService);

  PaymentProviderModalService.$inject = ['ModalService'];

  function PaymentProviderModalService(ModalService) {
    var service = {
      openSearchOpenPayments: openSearchOpenPayments,
    };

    return service;

    ////////////////////////

    function openSearchOpenPayments(filterCriteria, paymentProviderDocuments, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/payment-providers/modals/search-open-payments-modal.html',
        controller: SearchOpenPaymentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          filterCriteria: filterCriteria,
          paymentProviderDocuments: paymentProviderDocuments,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });
    }

    function SearchOpenPaymentsModalCtrl(
      $element,
      filterCriteria,
      paymentProviderDocuments,
      successCallback,
      PaymentProviderService,
      UtilService,
      CONFIGURATIONS
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);
      var config = CONFIGURATIONS;

      vm.modalTitle = 'OPEN_DOCUMENTS';

      vm.dateDisplay = config.DATE_DISPLAY;

      vm.selectDocument = selectDocument;

      // Initializers
      getOpenDocuments();

      function getOpenDocuments() {
        vm.loadingOpenDocuments = true;
        PaymentProviderService.searchOpenPayments(filterCriteria).then(function (data) {
          //vm.openDocuments = data;

          vm.openDocuments = vm.UtilService.getAvailableItemsInTwoArrays(
            data,
            paymentProviderDocuments,
            'document_id'
          );
          vm.loadingOpenDocuments = false;
        });
      }

      function selectDocument(item) {
        $element.modal('hide');
        successCallback(item);
      }
    }
  }
})();
